$(function () {

  var $dropdowns = $('.dropdown');

  $dropdowns.each(function() {
    var $this = $(this);

    $this.on('click', '[data-toggle=dropdown]', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if ($this.hasClass('disabled')) {
        return;
      }
      if ($this.hasClass('open')) {
        close();
      }
      else {
        open();
      }
    });

    function open() {
      $dropdowns.removeClass('open');
      $dropdowns.find('[data-toggle=dropdown]').attr('aria-expanded', false);
      $this.addClass('open');
      $this.find('[data-toggle=dropdown]').attr('aria-expanded', true);
      document.addEventListener('click', closeAll, { once: true });
    }
    function close() {
      $this.removeClass('open');
      $this.find('[data-toggle=dropdown]').attr('aria-expanded', false);
    }
    function closeAll() {
      $dropdowns.removeClass('open');
      $dropdowns.find('[data-toggle=dropdown]').attr('aria-expanded', false);
      document.removeEventListener('click', closeAll);
    }
  });
});